'use strict'

var sizeChunks = require('./size-chunks.js')

function prefixSize(events, type) {
  var tail = events[events.length - 1]
  if (!tail || tail[1].type !== type) return 0
  return sizeChunks(tail[2].sliceStream(tail[1]))
}

module.exports = prefixSize



//////////////////
// WEBPACK FOOTER
// ./node_modules/micromark/dist/util/prefix-size.js
// module id = 328
// module chunks = 0